import { render } from "./PartenaireViews.vue?vue&type=template&id=2019a2e5&scoped=true"
import script from "./PartenaireViews.vue?vue&type=script&lang=js"
export * from "./PartenaireViews.vue?vue&type=script&lang=js"

import "./PartenaireViews.vue?vue&type=style&index=0&id=2019a2e5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2019a2e5"]])

export default __exports__